// Port of api/fuel/app/classes/filter/core/helpers.php
// In the JS port, class discovery is handled by require.context() in index.js files.
// This module provides other utility functions used by the filter engine.
export default {
	indexed_result: function(items, field) {
		var result = {}
		for (var i = 0; i < items.length; i++) {
			result[items[i][field]] = items[i]
		}
		return result
	},
	preserve_sort: function(index, items, field) {
		var map = {}
		for (var i = 0; i < items.length; i++) map[items[i][field]] = items[i]
		var result = []
		for (var j = 0; j < index.length; j++) {
			if (map[index[j]]) result.push(map[index[j]])
		}
		return result
	}
}
